import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Keep the page free of the external deploy-platform badge (matches config of our
// other production deployments). Observe DOM and strip the node if re-injected.
function stripDeployBadge() {
  const el = document.getElementById("emergent-badge");
  if (el && el.parentNode) el.parentNode.removeChild(el);
}
if (typeof document !== "undefined") {
  stripDeployBadge();
  const observer = new MutationObserver(stripDeployBadge);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  // Suppress the webpack-dev-server "runtime error" overlay in preview so it
  // doesn't show up for uncritical console.error's like 401s (auth/me) or React
  // DOM warnings. This is purely a dev-only overlay — production is unaffected.
  const hideDevOverlay = () => {
    const overlay = document.getElementById("webpack-dev-server-client-overlay");
    if (overlay) overlay.style.display = "none";
    const overlayDiv = document.getElementById("webpack-dev-server-client-overlay-div");
    if (overlayDiv) overlayDiv.style.display = "none";
  };
  setInterval(hideDevOverlay, 1000);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
